import {
  Box,
  CloseRounded,
  CustomIconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  MuiAvatar,
  MuiDivider,
  MuiMenu,
  Typography,
  useMediaQuery,
  MuiMenuItem,
  DialogContentText,
} from "components/common";
import useFunctions from "layouts/authed-layout/ts/useFunctions";
import moment from "moment";
import { Fragment, MouseEvent, useState } from "react";
import { theme } from "theme";

export default function HeaderAccountMenu() {
  const { user, handleAuthReset } = useFunctions();
  const [profileDialog, setProfileDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileDialogToggle = () => {
    setProfileDialog((prev) => !prev);
  };
  return (
    <Fragment>
      <CustomIconButton
        color="secondary"
        sx={{
          padding: "0 !important",
          display: { xs: "none", md: "flex" },
        }}
        onClick={handleClick}
      >
        <MuiAvatar
          sx={{
            width: "46px",
            height: "46px",
          }}
        >
          {user.first_name.charAt(0) + user.last_name.charAt(0)}
        </MuiAvatar>
      </CustomIconButton>
      <MuiMenu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        MenuListProps={{
          sx: {
            p: 1,
            color: "black",
          },
        }}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              bgcolor: "background.paper",
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {[
          {
            title: "Profile",
            onClick: handleProfileDialogToggle,
          },
          {
            title: "Settings",
          },
          {
            title: "Logout",
            onClick: handleAuthReset,
          },
        ].map(({ title, onClick }, index) => (
          <Box>
            <MuiMenuItem
              sx={{
                borderRadius: "10px",
                "& .MuiTypography-root": {
                  color: "black",
                },
                "&:hover": {
                  backgroundColor: "primary.main",
                  "& .MuiTypography-root": {
                    color: "white",
                  },
                },
              }}
              onClick={onClick && onClick}
            >
              <Typography>{title}</Typography>
            </MuiMenuItem>
            {index === 0 && <MuiDivider sx={{ my: 1 }} />}
          </Box>
        ))}
      </MuiMenu>
      <Dialog
        open={profileDialog}
        onClose={() => handleProfileDialogToggle()}
        fullScreen={fullScreen}
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "600px",
          },
        }}
      >
        <DialogContent>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Box display={"flex"} alignItems="center" gap={3}>
              <CustomIconButton
                color="primary"
                onClick={() => handleProfileDialogToggle()}
              >
                <CloseRounded />
              </CustomIconButton>
              <DialogTitle
                sx={{
                  color: "#666",
                  fontSize: "36px",
                }}
              >
                User Profile
              </DialogTitle>
            </Box>
          </Box>
          <Box display="flex" flexDirection="column" gap={2}>
            <Box>
              <DialogContentText>Joined:</DialogContentText>
              <Typography color={theme.palette.primary.main}>
                {moment(user.created_at.seconds * 1000).format(
                  "MMM DD,YYYY HH:mm"
                )}
              </Typography>
            </Box>

            <Box display="flex" gap={2}>
              <Box flex={1}>
                <DialogContentText>First Name:</DialogContentText>
                <Typography color={theme.palette.primary.main}>
                  {user.first_name}
                </Typography>
              </Box>
              <Box flex={1}>
                <DialogContentText>Last Name:</DialogContentText>
                <Typography color={theme.palette.primary.main}>
                  {user.last_name}
                </Typography>
              </Box>
            </Box>

            <Box display="flex" gap={2}>
              <Box flex={1}>
                <DialogContentText>Email Address:</DialogContentText>
                <Typography color={theme.palette.primary.main}>
                  {user.email}
                </Typography>
              </Box>
              <Box flex={1}>
                <DialogContentText>Phone Number:</DialogContentText>
                <Typography color={theme.palette.primary.main}>
                  {user.phone_number}
                </Typography>
              </Box>
            </Box>

            <Box display="flex" gap={2}>
              <Box flex={1}>
                <DialogContentText>Dealer:</DialogContentText>
                <Typography color={theme.palette.primary.main}>
                  {user.isDealer ? "Yes" : "No"}
                </Typography>
              </Box>
              <Box flex={1}>
                {user.isDealer && (
                  <Fragment>
                    <DialogContentText>Dealer:</DialogContentText>
                    <Typography
                      color={
                        user.dealerDetails.progress === "rejected"
                          ? theme.palette.error.main
                          : theme.palette.primary.main
                      }
                      textTransform="capitalize"
                    >
                      {user.dealerDetails.progress}
                    </Typography>
                  </Fragment>
                )}
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}
